import { render, staticRenderFns } from "./sendPush.vue?vue&type=template&id=5baa3b82&scoped=true&"
import script from "./sendPush.vue?vue&type=script&lang=js&"
export * from "./sendPush.vue?vue&type=script&lang=js&"
import style0 from "./sendPush.vue?vue&type=style&index=0&id=5baa3b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa3b82",
  null
  
)

export default component.exports